module.exports = __webpack_public_path__ + "img/dark-narrow-street-thumb.a08a2ecc.jpg";